import { useState, useRef, useEffect } from "react";
import "./ChatBot.css";
import { GoogleGenAI } from "@google/genai";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {APP_URL,API_ENDPOINT, toast_anim , pdfdoconly} from '../../components/config/Common'


export default function ChatBot() {
  const [isOpen, setIsOpen] = useState(false);
  const [typing, setTyping] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: "model",
      parts: [
        {
          text: "Hello 👋 I'm here to listen.\nWhat's been on your mind lately?"
        }
      ]
    },
  ]);

  const bottomRef = useRef(null);

  useEffect(() => {
      bottomRef.current?.scrollIntoView({
          behavior: "smooth"
      });
  }, [messages]);

  const [input, setInput] = useState("");

  const sendMessage = async () => {
    if (!input.trim()) return;

    const message = input;

    const updatedMessages = [
    ...messages,
    {
        role: "user",
        parts: [
            {
                text: message
            }
        ]
    }
];

setMessages(updatedMessages);

    // Add user message
    // setMessages((prev) => [
    //     ...prev,
    //     {
    //         role: "user",            
    //         parts: [
    //             {
    //                 text: message
    //             }
    //         ]
    //     },
    // ]);

    setInput("");
    setTyping(true);
    console.log(JSON.stringify(updatedMessages, null, 2));
    try {
        const response = await fetch(`${API_ENDPOINT}/chat`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify({
                contents: updatedMessages,
            }),
        });

        const data = await response.json();
        setTyping(false);
        console.log("data=====", data);

        const botMessage = {
            role: "model",
            parts: [
                {
                    text: data.reply
                }
            ]
        };

        setMessages(prev => [...prev, botMessage]);

        // setMessages((prev) => [
        //     ...prev,
        //     {
        //         role: "bot",
        //         parts: [
        //             {
        //                 text: data.reply
        //             }
        //         ]
        //     },
        // ]);
    } catch (error) {
        console.error(error);
        setTyping(false);
        setMessages((prev) => [
            ...prev,
            {
                role: "model",
                parts: [
                    {
                        text: "Sorry, something went wrong."
                    }
                ]
            },
        ]);
    }
};

  return (
    <>
      {/* Floating Button */}
      <button
        className="chat-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? "✕" : "Talk to AI"}
      </button>

      {isOpen && (
        <div className="chat-popup">

          <div className="chat-header">
            AI Assistant
          </div>

          <div className="chat-body">

            {messages.map((msg, index) => (
              <div
                key={index}
                className={`message ${msg.role === "user" ? "user" : "bot"}`}
              >
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {msg.parts[0].text}
                </ReactMarkdown>
              </div>
            ))}
            {typing && (
                <div className="message bot typing">
                    AI is typing...
                </div>
            )}
            <div ref={bottomRef} />

          </div>

          <div className="chat-footer">

            <input
              type="text"
              placeholder="Type message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") sendMessage();
              }}
            />

            <button onClick={sendMessage}>
              Send
            </button>

          </div>

        </div>
      )}
    </>
  );
}